if (!customElements.get('sh-vertical-thumbnails')) {
  customElements.define('sh-vertical-thumbnails', class extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('.thumbnail-list');
      this.desktop = window.matchMedia('(min-width: 750px)');
      this.slider = {
        scrollTo: (options) => {
          if (!this.list) return;
          if (this.desktop.matches && this.target) {
            this.list.scrollTo({
              top: this.target.offsetTop - this.list.offsetTop,
              left: 0
            });
          } else {
            this.list.scrollTo(options);
          }
        }
      };
    }

    isSlideVisible(thumbnail, offset = 0) {
      this.target = thumbnail;
      if (!this.list || !thumbnail) return true;
      const item = thumbnail.getBoundingClientRect();
      const viewport = this.list.getBoundingClientRect();
      return this.desktop.matches
        ? item.top >= viewport.top && item.bottom <= viewport.bottom - offset
        : item.left >= viewport.left && item.right <= viewport.right - offset;
    }
  });
}
